import { SESSION_CLIENT_PAYMENT_STATUSES } from '@admin/constants/general'
import { BADGE_VARIANTS } from 'components/Badge'
import { SESSION_CLIENT_STATUSES, SESSION_STATUSES } from 'constants/common'
import { type StatusBadgeMapper } from './types'

export const SESSION_CLIENT_PAYMENT_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [SESSION_CLIENT_PAYMENT_STATUSES.PENDING]: {
    variant: BADGE_VARIANTS.BLUE,
  },
  [SESSION_CLIENT_PAYMENT_STATUSES.ON_HOLD]: {
    variant: BADGE_VARIANTS.BROWN,
  },
  [SESSION_CLIENT_PAYMENT_STATUSES.PAID]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [SESSION_CLIENT_PAYMENT_STATUSES.CANCELLED]: {
    variant: BADGE_VARIANTS.RED,
  },
} as const

export const SESSION_CLIENT_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [SESSION_CLIENT_STATUSES.PENDING]: {
    variant: BADGE_VARIANTS.BLUE,
  },
  [SESSION_CLIENT_STATUSES.APPROVED]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [SESSION_CLIENT_STATUSES.CANCELLED]: {
    variant: BADGE_VARIANTS.RED,
  },
  [SESSION_CLIENT_STATUSES.DECLINED]: {
    variant: BADGE_VARIANTS.ORANGE,
  },
} as const

export const SESSION_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [SESSION_STATUSES.PENDING]: {
    variant: BADGE_VARIANTS.BLUE,
  },
  [SESSION_STATUSES.FINISHED]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [SESSION_STATUSES.CANCELLED]: {
    variant: BADGE_VARIANTS.RED,
  },
} as const
